import { createGlobalStyle } from "styled-components";

export const theme = {
  colors: {
    first: "#ffffff",
    second: "#e1e7ec",
    third: "#cad5df",
    surface: "#f6f8fa",
    surface_alt: "#eef3f7",
    border: "#cfd9e2",
    button: "#b0b0b0",
    button_green: "#00ff00",
    button_red: "#ba2121",
    button_red_hover: "#a41515",
    text: "#1f2b34",
    text_muted: "#5e6f7d",
    accent: "#417690",
    day: "#ffd700",
    night: "#1a237e",
  },
};

const GlobalStyle = createGlobalStyle`
  :root {
    --ui-surface: #f6f8fa;
    --ui-surface-alt: #eef3f7;
    --ui-bg: #ffffff;
    --ui-border: #cfd9e2;
    --ui-text: #1f2b34;
    --ui-text-muted: #5e6f7d;
    --ui-accent: #417690;
    --ui-accent-strong: #264b5d;
    --ui-danger: #ba2121;
    --ui-day: #ffd700;
    --ui-night: #1a237e;
    --radius-sm: 6px;
    --radius-md: 10px;
    --shadow-soft: 0 2px 10px rgba(24, 39, 52, 0.08);
  }

  * {
    user-select: none;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Segoe UI", "Roboto", "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif;
    overflow: hidden;
    background-color: var(--ui-bg);
    scrollbar-width: thin;
    scrollbar-color: #79aec8 white;
  };

  overflow-x: hidden;

  body {
    font-weight: 500;
    color: var(--ui-text);
    letter-spacing: 0.01em;
    background-color: var(--ui-surface);
  }

  strong {
    font-weight: 700;
  }

  /* Modern scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: white;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #79aec8;
    border-radius: 20px;
    border: 3px solid #f5f5f5;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

`;

export default GlobalStyle;
